import { Injectable } from '@angular/core';
import es6printJS from 'print-js';
import { HttpClient } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { ConfirmService } from './confirm.service';

@Injectable({
    providedIn: 'root'
})
export class PrinterService {

    usbDevice = null;

    constructor(private httpClient: HttpClient, private confirmService: ConfirmService) {
    }

    public printPdf(url): void {
        es6printJS(url);
    }

    public printImage(url: string): void {
        es6printJS(url, 'image');
    }

    public printZpl(url: string): void {
        if (this.isWebUsbEnabled()) {
            this.getUsbDevice().then(device => {
                if (device) {
                    this.httpClient.get(url, { responseType: 'arraybuffer' }).pipe(
                        switchMap((b) => from(device.transferOut(1, b)))
                    ).subscribe();
                } else {
                    this.confirmService.information($localize`No Compatible Printer`,
                        $localize`To print thermal labels you must connect a Zebra (or compatible) printer via USB and allow access when asked.`);
                }
            });
        } else {
            this.confirmService.information($localize`Thermal Printing Not Supported`,
                $localize`To print with a USB connected thermal printer, you must use use Chrome or Edge.`);
        }
    }

    protected isWebUsbEnabled(): boolean {
        return navigator['usb'] !== undefined;
    }

    protected getWebUsb(): any {
        return navigator['usb'];
    }

    protected async getUsbDevice(): Promise<any> {
        if (this.usbDevice === null) {
            const devices = await this.getWebUsb().getDevices();
            if (devices.length > 0) {
                this.usbDevice = devices[0];
            } else {
                this.usbDevice = await this.getWebUsb().requestDevice({
                    filters: [ { vendorId: 2655 } ]
                });
            }
            if (this.usbDevice) {
                await this.usbDevice.open();
                await this.usbDevice.selectConfiguration(1);
                await this.usbDevice.claimInterface(0);
            }
        }
        return this.usbDevice;
    }
}
